import React, { lazy, Suspense } from 'react';

const Overlay = lazy(() => import('./Overlay.next'));

export default function OverlayAsyncNext(
  props: React.ComponentProps<typeof Overlay>
) {
  return (
    <Suspense fallback={null}>
      <Overlay {...props} />
    </Suspense>
  );
}
